export default "__VITE_ASSET__Bs3U9Hd6__"